module.exports = __webpack_public_path__ + "media/images/emblems/Wimmis-coat_of_arms-73944b626fc7a24235347ef6f9774afd.svg";